import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Nav from './Nav'
import Land from './Land'
import Templater from './Templater'
import Loader from './Loader'

import 'bootstrap/dist/js/bootstrap.bundle'
import 'jquery.easing/jquery.easing'
import 'jquery.easing/jquery.easing.compatibility'

import '../js/jqBootstrapValidation'

import '../js/agency'
import matchPath from 'react-router-dom/matchPath';



class Home extends Component {
  render() {
      return (
       
        <Loader>
        <Router>
          <div>
         
          {/* Navigation */}
          <nav className="navbar navbar-expand-lg navbar-dark fixed-top " id="mainNav" >
            <Nav />
          </nav>

          <Route exact path="/" component={Land} />
          <Route path="/portfolio/:template" component={ (props) => <Templater template={props.match.params.template} />} />
         
      
          {/* w3 */}
          {/* Bootstrap core JavaScript */}
          {/* Plugin JavaScript */}
          {/* Contact form JavaScript */}
          {/* Custom scripts for this template */}
        </div>

        </Router>
        </Loader>
      );
    }
  };

  export default Home